import { routes } from '@/app/routing/router'
import { OnboardingPage } from './view.tsx'

const currentRoute = routes.onboarding

const OnboardingPageRoute = {
  view: OnboardingPage,
  route: currentRoute,
}

export { currentRoute, OnboardingPageRoute }
